import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export const constantRoutes = [

    {
        path: '/login',
        component: () => import('@/views/Login.vue'),
        hidden: true
    },

    {
        path: '/',
        name: 'Layout',
        redirect: '/home/index',
    },


    //#A

    {
        path: '/AlarmRecord',
        name: 'AlarmRecord',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'Page',
                component: () => import('@/views/AlarmRecord/Page'),
            },
            {
                path: 'GovPageIns',
                component: () => import('@/views/AlarmRecord/Gov/PageIns'),
            },
            {
                path: 'AdminPage',
                component: () => import('@/views/AlarmRecord/Admin/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/AlarmRecord/Reg/Page'),
            },
        ]
    },
    {
        path: '/AccountingRecord',
        name: 'AccountingRecord',
        component: () => import('@/layout/IndexNew'),
        redirect: '/AccountingRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/AccountingRecord/Page'),
            },
        ]
    },
    {
        path: '/AppCare',
        name: 'AppCare',
        component: () => import('@/layout/IndexNew'),
        redirect: '/AppCare/OrderBusinessAppraisePageForGov',
        children: [
            {
                path: 'OrderBusinessAppraisePageForGov',
                component: () => import('@/views/AppCare/OrderBusinessAppraisePageForGov'),
            },
        ]
    },
    {
        path: '/Area',
        name: 'Area',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Area/List',
        children: [
            {
                path: 'List',
                component: () => import('@/views/Area/List'),
            },
        ]
    },
    {
        path: '/AppVersion',
        name: 'AppVersion',
        component: () => import('@/layout/IndexNew'),
        redirect: '/AppVersion/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/AppVersion/Page'),
            },
        ]
    },
    {
        path: '/ArticleClass',
        name: 'ArticleClass',
        component: () => import('@/layout/IndexNew'),
        redirect: '/ArticleClass/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ArticleClass/Page'),
            },
        ]
    },
    {
        path: '/Article',
        name: 'Article',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'CommandCenterPageNews',
                component: () => import('@/views/Article/CommandCenter/PageNews'),
            },
            {
                path: 'CommandCenterPageZhengce',
                component: () => import('@/views/Article/CommandCenter/PageZhengce'),
            },
            {
                path: 'GovPageNews',
                component: () => import('@/views/Article/Gov/PageNews'),
            },
            {
                path: 'GovPageZhengce',
                component: () => import('@/views/Article/Gov/PageZhengce'),
            },
            {
                path: 'RegPageNews',
                component: () => import('@/views/Article/Reg/PageNews'),
            },
            {
                path: 'RegPageZhengce',
                component: () => import('@/views/Article/Reg/PageZhengce'),
            },
        ]
    },
    {
        path: '/ActivityClass',
        name: 'ActivityClass',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'CommandCenterPage',
                component: () => import('@/views/ActivityClass/CommandCenter/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/ActivityClass/Gov/Page'),
            },
        ]
    },
    {
        path: '/ActivityContent',
        name: 'ActivityContent',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'CommandCenterPage',
                component: () => import('@/views/ActivityContent/CommandCenter/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/ActivityContent/Gov/Page'),
            },
        ]
    },
    {
        path: '/AskAnswerName',
        name: 'AskAnswerName',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'CommandCenterPage',
                component: () => import('@/views/AskAnswerName/CommandCenter/Page'),
            },
        ]
    },
    {
        path: '/AskAnswerGroup',
        name: 'AskAnswerGroup',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'CommandCenterPage',
                component: () => import('@/views/AskAnswerGroup/CommandCenter/Page'),
            },
        ]
    },
    {
        path: '/AskAnswerRecord',
        name: 'AskAnswerRecord',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'CommandCenterPage',
                component: () => import('@/views/AskAnswerRecord/CommandCenter/Page'),
            },
        ]
    },
    {
        path: '/ActivityOrder',
        name: 'ActivityOrder',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'CommandCenterPageApply',
                component: () => import('@/views/ActivityOrder/CommandCenter/PageApply'),
            },
            {
                path: 'CommandCenterPagePass',
                component: () => import('@/views/ActivityOrder/CommandCenter/PagePass'),
            },
            {
                path: 'CommandCenterPageReceive',
                component: () => import('@/views/ActivityOrder/CommandCenter/PageReceive'),
            },
            {
                path: 'CommandCenterPageEvaluate',
                component: () => import('@/views/ActivityOrder/CommandCenter/PageEvaluate'),
            },
            {
                path: 'CommandCenterPageTotal',
                component: () => import('@/views/ActivityOrder/CommandCenter/PageTotal'),
            },
            {
                path: 'CommandCenterPageEvaluate2',
                component: () => import('@/views/ActivityOrder/CommandCenter/PageEvaluate2'),
            },

            {
                path: 'GovPage',
                component: () => import('@/views/ActivityOrder/Gov/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/ActivityOrder/Reg/PageEvaluate'),
            },
        ]
    },
    {
        path: '/AppBannerElderly',
        name: 'AppBannerElderly',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'Page',
                component: () => import('@/views/AppBannerElderly/Page'),
            },
        ]
    },
    {
        path: '/AdvanceRecord',
        name: 'AdvanceRecord',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/AdvanceRecord/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/AdvanceRecord/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/AdvanceRecord/Gov/PageDayCare'),
            },

            {
                path: 'Page',
                component: () => import('@/views/AdvanceRecord/Page'),
            },
        ]
    },
    {
        path: '/AccidentRecord',
        name: 'AccidentRecord',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'Page',
                component: () => import('@/views/AccidentRecord/Page'),
            },
            {
                path: 'GovPageIns',
                component: () => import('@/views/AccidentRecord/Gov/PageIns'),
            },
        ]
    },
    {
        path: '/Assess',
        name: 'Assess',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/Assess/Ins/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/Assess/Gov/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/Assess/Reg/Page'),
            },
        ]
    },
    {
        path: '/AssessElderlyRel',
        name: 'AssessElderlyRel',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/AssessElderlyRel/Ins/Page'),
            },
            {
                path: 'InsCheckPage',
                component: () => import('@/views/AssessElderlyRel/Ins/CheckPage'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/AssessElderlyRel/Gov/Page'),
            },
            {
                path: 'GovCheckPage',
                component: () => import('@/views/AssessElderlyRel/Gov/CheckPage'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/AssessElderlyRel/Reg/Page'),
            },
        ]
    },
    {
        path: '/ActivityUser',
        name: 'ActivityUser',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPage',
                component: () => import('@/views/ActivityUser/Gov/Page'),
            },
        ]
    },





    //#B

    {
        path: '/BusinessAccount',
        name: 'BusinessAccount',
        component: () => import('@/layout/IndexNew'),
        redirect: '/BusinessAccount/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/BusinessAccount/Page'),
            },
        ]
    },
    {
        path: '/Business',
        name: 'Business',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'AdminPage',
                component: () => import('@/views/Business/Admin/Page'),
            },
            {
                path: 'PageGov',
                component: () => import('@/views/Business/PageGov'),
            },

            {
                path: 'GovPageHomeService',
                component: () => import('@/views/Business/Gov/PageHomeService'),
            },
            {
                path: 'GovPageDisable',
                component: () => import('@/views/Business/Gov/PageDisable'),
            },
            {
                path: 'GovPageCanteen',
                component: () => import('@/views/Business/Gov/PageCanteen'),
            },
            {
                path: 'GovPageIntegration',
                component: () => import('@/views/Business/Gov/PageIntegration'),
            },
            {
                path: 'GovPageTrip',
                component: () => import('@/views/Business/Gov/PageTrip'),
            },
            {
                path: 'GovPageCommunity',
                component: () => import('@/views/Business/Gov/PageCommunity'),
            },


            {
                path: 'PageSuper',
                component: () => import('@/views/Business/PageSuper'),
            },

            {
                path: 'RegPageHomeService',
                component: () => import('@/views/Business/Reg/PageHomeService'),
            },
            {
                path: 'RegPageCanteen',
                component: () => import('@/views/Business/Reg/PageCanteen'),
            },
            {
                path: 'RegPageIntegration',
                component: () => import('@/views/Business/Reg/PageIntegration'),
            },


        ]
    },
    {
        path: '/BusinessBank',
        name: 'BusinessBank',
        component: () => import('@/layout/IndexNew'),
        redirect: '/BusinessBank/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/BusinessBank/Page'),
            }
        ]
    },
    {
        path: '/Berth',
        name: 'Berth',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/Berth/Ins/Page'),
            },
            {
                path: 'InsState',
                component: () => import('@/views/Berth/Ins/State'),
            },

            {
                path: 'GovPage',
                component: () => import('@/views/Berth/Gov/Page'),
            },
            {
                path: 'GovState',
                component: () => import('@/views/Berth/Gov/State'),
            },

            {
                path: 'RegPage',
                component: () => import('@/views/Berth/Reg/Page'),
            },

        ]
    },
    {
        path: '/Building',
        name: 'Building',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/Building/Ins/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/Building/Gov/Page'),
            }
        ]
    },
    {
        path: '/BalanceRecord',
        name: 'BalanceRecord',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/BalanceRecord/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/BalanceRecord/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/BalanceRecord/Gov/PageDayCare'),
            },

            {
                path: 'InsPage',
                component: () => import('@/views/BalanceRecord/Ins/Page'),
            },

        ]
    },
    {
        path: '/BedGoodsClass',
        name: 'BedGoodsClass',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPage',
                component: () => import('@/views/BedGoodsClass/Gov/Page'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/BedGoodsClass/Ins/Page'),
            },

        ]
    },
    {
        path: '/BedGoods',
        name: 'BedGoods',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/BedGoods/Ins/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/BedGoods/Gov/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/BedGoods/Reg/Page'),
            },
        ]
    },
    {
        path: '/Build',
        name: 'Build',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/Build/Ins/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/Build/Gov/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/Build/Reg/Page'),
            },

        ]
    },

    //#C

    {
        path: '/Call',
        name: 'Call',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Call/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Call/Page'),
            },
            {
                path: 'PageVideo',
                component: () => import('@/views/Call/PageVideo'),
            },
        ]
    },
    {
        path: '/ConsultRecord',
        name: 'ConsultRecord',
        component: () => import('@/layout/IndexNew'),
        redirect: '/ConsultRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ConsultRecord/Page'),
            },
        ]
    },
    {
        path: '/Care',
        name: 'Care',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Care/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Care/Page'),
            },
        ]
    },
    {
        path: '/CardRecord',
        name: 'CardRecord',
        component: () => import('@/layout/IndexNew'),
        redirect: '/CardRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/CardRecord/Page'),
            },
        ]
    },
    {
        path: '/Complaint',
        name: 'Complaint',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Complaint/Page'),
            },
        ]
    },
    {
        path: '/Cashier',
        name: 'Cashier',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Cashier/Business/Page'),
            },
            {
                path: 'BusinessPage',
                component: () => import('@/views/Cashier/Business/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/Cashier/Gov/Page'),
            },

            {
                path: 'RegPage',
                component: () => import('@/views/Cashier/Reg/Page'),
            },
        ]
    },
    {
        path: '/CommandCenter',
        name: 'CommandCenter',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPage',
                component: () => import('@/views/CommandCenter/Gov/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/CommandCenter/Reg/Page'),
            },
        ]
    },
    {
        path: '/CheckinAssessClass',
        name: 'CheckinAssessClass',
        component: () => import('@/layout/IndexNew'),
        children: [
            {//del
                path: 'GovPage',
                component: () => import('@/views/CheckinAssessClass/Gov/Page'),
            },
            {
                path: 'GovPageIns',
                component: () => import('@/views/CheckinAssessClass/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/CheckinAssessClass/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/CheckinAssessClass/Gov/PageDayCare'),
            },

            {
                path: 'InsPage',
                component: () => import('@/views/CheckinAssessClass/Ins/Page'),
            },
        ]
    },
    {
        path: '/CheckinAssessGroup',
        name: 'CheckinAssessGroup',
        component: () => import('@/layout/IndexNew'),
        redirect: '/CheckinAssessGroup/GovPage',
        children: [
            {//del
                path: 'GovPage',
                component: () => import('@/views/CheckinAssessGroup/Gov/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/CheckinAssessGroup/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/CheckinAssessGroup/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/CheckinAssessGroup/Gov/PageDayCare'),
            },

            {
                path: 'InsPage',
                component: () => import('@/views/CheckinAssessGroup/Ins/Page'),
            },
        ]
    },
    {
        path: '/CheckinSetmeal',
        name: 'CheckinSetmeal',
        component: () => import('@/layout/IndexNew'),
        children: [
            {//del
                path: 'GovPage',
                component: () => import('@/views/CheckinSetmeal/Gov/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/CheckinSetmeal/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/CheckinSetmeal/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/CheckinSetmeal/Gov/PageDayCare'),
            },


            {
                path: 'RegPageIns',
                component: () => import('@/views/CheckinSetmeal/Reg/PageIns'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/CheckinSetmeal/Ins/Page'),
            },
            {
                path: 'InsHomeBedPage',
                component: () => import('@/views/CheckinSetmeal/InsHomeBed/Page'),
            },
            {
                path: 'InsDayCarePage',
                component: () => import('@/views/CheckinSetmeal/InsDayCare/Page'),
            }
        ]
    },
    {
        path: '/Checkin',
        name: 'Checkin',
        component: () => import('@/layout/IndexNew'),
        children: [

            {
                path: 'AdminPageIns',
                component: () => import('@/views/Checkin/Admin/PageIns'),
            },
            {
                path: 'AdminPageHomeBed',
                component: () => import('@/views/Checkin/Admin/PageHomeBed'),
            },
            {
                path: 'AdminPageDayCare',
                component: () => import('@/views/Checkin/Admin/PageDayCare'),
            },

            {//del
                path: 'GovPage',
                component: () => import('@/views/Checkin/Gov/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/Checkin/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/Checkin/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/Checkin/Gov/PageDayCare'),
            },


            {
                path: 'RegPageIns',
                component: () => import('@/views/Checkin/Reg/PageIns'),
            },
            {
                path: 'RegPageHomeBed',
                component: () => import('@/views/Checkin/Reg/PageHomeBed'),
            },

            {
                path: 'InsPage',
                component: () => import('@/views/Checkin/Ins/Page'),
            },
            {
                path: 'InsHomeBedPage',
                component: () => import('@/views/Checkin/InsHomeBed/Page'),
            },
            {
                path: 'InsDayCarePage',
                component: () => import('@/views/Checkin/InsDayCare/Page'),
            },

        ]
    },
    {
        path: '/CheckinAssessWait',
        name: 'CheckinAssessWait',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPage',
                component: () => import('@/views/CheckinAssessWait/Gov/Page'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/CheckinAssessWait/Ins/Page'),
            },
            {
                path: 'MedicinerPage',
                component: () => import('@/views/CheckinAssessWait/Mediciner/Page'),
            },
            {
                path: 'NursePage',
                component: () => import('@/views/CheckinAssessWait/Nurse/Page'),
            }
        ]
    },
    {
        path: '/Children',
        name: 'Children',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPage',
                component: () => import('@/views/Children/Gov/Page'),
            },
        ]
    },
    {
        path: '/CheckWardRecord',
        name: 'CheckWardRecord',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/CheckWardRecord/Gov/PageIns'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/CheckWardRecord/Ins/Page'),
            },
        ]
    },
    {
        path: '/Check',
        name: 'Check',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/Check/Ins/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/Check/Gov/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/Check/Reg/Page'),
            },
        ]
    },

    //#D

    {
        path: '/Device',
        name: 'Device',
        component: () => import('@/layout/IndexNew'),
        children: [

            {
                path: 'WatchH09GovPageOut',
                component: () => import('@/views/Device/WatchH09/Gov/PageOut'),
            },
            {
                path: 'WatchH09GovPageOutIns',
                component: () => import('@/views/Device/WatchH09/Gov/PageOutIns'),
            },


            {
                path: 'XueTangYiGovPage',
                component: () => import('@/views/Device/XueTangYi/Gov/Page'),
            },
            {
                path: 'XueTangYiGovPageDisable',
                component: () => import('@/views/Device/XueTangYi/Gov/PageDisable'),
            },
            {
                path: 'PageAiaoleGov',
                component: () => import('@/views/Device/PageXYJGov/PageAiaoleGov'),
            },
            {
                path: 'PageAiaoleGovDisable',
                component: () => import('@/views/Device/PageXYJGov/PageDisable'),
            },
            {
                path: 'PageGatewayGov',
                component: () => import('@/views/Device/PageGatewayGov/PageGatewayGov'),
            },
            {
                path: 'PageExamGov',
                component: () => import('@/views/Device/PageExamGov/PageGov'),
            },



            {
                path: 'OWonNBGovPage',
                component: () => import('@/views/Device/OWonNB/Gov/Page'),
            },
            {
                path: 'OWonNBGovPageDisable',
                component: () => import('@/views/Device/OWonNB/Gov/PageDisable'),
            },
            {
                path: 'OWonNBZonePage',
                component: () => import('@/views/Device/OWonNB/Zone/Page'),
            },
            {
                path: 'OWonNBBusinessPage',
                component: () => import('@/views/Device/OWonNB/Business/Page'),
            },
            {
                path: 'OWonNBInsPage',
                component: () => import('@/views/Device/OWonNB/Ins/Page'),
            },

            {
                path: 'OWonCatGovPage',
                component: () => import('@/views/Device/OWonCat/Gov/Page'),
            },
            {
                path: 'OWonCatGovPageDisable',
                component: () => import('@/views/Device/OWonCat/Gov/PageDisable'),
            },
            {
                path: 'OWonCatGovPageIns',
                component: () => import('@/views/Device/OWonCat/Gov/PageIns'),
            },

            {
                path: 'SBJGovPage',
                component: () => import('@/views/Device/ShuiBeiJian/Gov/Page'),
            },
            {
                path: 'SBJGovPageIns',
                component: () => import('@/views/Device/ShuiBeiJian/Gov/PageIns'),
            },
            {
                path: 'SBJZonePage',
                component: () => import('@/views/Device/ShuiBeiJian/Zone/Page'),
            },
            {
                path: 'SBJBusinessPage',
                component: () => import('@/views/Device/ShuiBeiJian/Business/Page'),
            },
            {
                path: 'SBJInsPage',
                component: () => import('@/views/Device/ShuiBeiJian/Ins/Page'),
            },


            {
                path: 'WatchH09GovPage',
                component: () => import('@/views/Device/WatchH09/Gov/Page'),
            },
            {
                path: 'WatchH09GovPageDisable',
                component: () => import('@/views/Device/WatchH09/Gov/PageDisable'),
            },
            {
                path: 'WatchH09GovPageIns',
                component: () => import('@/views/Device/WatchH09/Gov/PageIns'),
            },
            {
                path: 'WatchH09RegPage',
                component: () => import('@/views/Device/WatchH09/Reg/Page'),
            },
            {
                path: 'WatchH09ZonePage',
                component: () => import('@/views/Device/WatchH09/Zone/Page'),
            },
            {
                path: 'WatchH09BusinessPage',
                component: () => import('@/views/Device/WatchH09/Business/Page'),
            },
            {
                path: 'WatchH09InsPage2',
                component: () => import('@/views/Device/WatchH09/Ins/Page2'),
            },
            {
                path: 'WatchH09AdminPage',
                component: () => import('@/views/Device/WatchH09/Admin/Page'),
            },


            {
                path: 'CameraGovPage',
                component: () => import('@/views/Device/Camera/Gov/Page'),
            },
            {
                path: 'CameraGovPageDisable',
                component: () => import('@/views/Device/Camera/Gov/PageDisable'),
            },
            {
                path: 'CameraZonePage',
                component: () => import('@/views/Device/Camera/Zone/Page'),
            },
            {
                path: 'CameraBusinessPage',
                component: () => import('@/views/Device/Camera/Business/Page'),
            },

            {
                path: 'SixPCGovPage',
                component: () => import('@/views/Device/SixPC/Gov/Page'),
            },
            {
                path: 'SixPCZonePage',
                component: () => import('@/views/Device/SixPC/Zone/Page'),
            },
            {
                path: 'SixPCBusinessPage',
                component: () => import('@/views/Device/SixPC/Business/Page'),
            },



            {
                path: 'QLSignGovPage',
                component: () => import('@/views/Device/QLSign/Gov/Page'),
            },
            {
                path: 'QLSignGovPageDisable',
                component: () => import('@/views/Device/QLSign/Gov/PageDisable'),
            },
            {
                path: 'QLSignGovPageIns',
                component: () => import('@/views/Device/QLSign/Gov/PageIns'),
            },
            {
                path: 'QLSignInsPage',
                component: () => import('@/views/Device/QLSign/Ins/Page'),
            },
            {
                path: 'QLSignGovPageInsBerth',
                component: () => import('@/views/Device/QLSign/Gov/PageInsBerth'),
            },



            {
                path: 'QLFallGovPage',
                component: () => import('@/views/Device/QLFall/Gov/Page'),
            },
            {
                path: 'QLFallGovPageOutIns',
                component: () => import('@/views/Device/QLFall/Gov/PageOutIns'),
            },
            {
                path: 'QLFallGovPageDisable',
                component: () => import('@/views/Device/QLFall/Gov/PageDisable'),
            },
            {
                path: 'QLFallGovPageIns',
                component: () => import('@/views/Device/QLFall/Gov/PageIns'),
            },
            {
                path: 'QLFallInsPage',
                component: () => import('@/views/Device/QLFall/Ins/Page'),
            },

            {
                path: 'XDuGovPage',
                component: () => import('@/views/Device/XDu/Gov/Page'),
            },
            {
                path: 'XDuGovPageDisable',
                component: () => import('@/views/Device/XDu/Gov/PageDisable'),
            },
            {
                path: 'XDuGovPageIns',
                component: () => import('@/views/Device/XDu/Gov/PageIns'),
            },
            {
                path: 'XDuInsPage',
                component: () => import('@/views/Device/XDu/Ins/Page'),
            },

            {
                path: 'CameraPhilipsGovPage',
                component: () => import('@/views/Device/CameraPhilips/Gov/Page'),
            },
            {
                path: 'CameraPhilipsGovPageDisable',
                component: () => import('@/views/Device/CameraPhilips/Gov/PageDisable'),
            },


            {
                path: 'TempGovPage',
                component: () => import('@/views/Device/Temp/Gov/Page'),
            },
            {
                path: 'TempGovPageDisable',
                component: () => import('@/views/Device/Temp/Gov/PageDisable'),
            },
            {
                path: 'TempGovPageIns',
                component: () => import('@/views/Device/Temp/Gov/PageIns'),
            },


        ]
    },
    {
        path: '/DataDanguchun',
        name: 'DataDanguchun',
        component: () => import('@/layout/IndexNew'),
        redirect: '/DataDanguchun/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DataDanguchun/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/DataDanguchun/RegPage'),
            },
        ]
    },
    {
        path: '/DataNiaosuan',
        name: 'DataNiaosuan',
        component: () => import('@/layout/IndexNew'),
        redirect: '/DataNiaosuan/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DataNiaosuan/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/DataNiaosuan/RegPage'),
            },
        ]
    },
    {
        path: '/DataXuetang',
        name: 'DataXuetang',
        component: () => import('@/layout/IndexNew'),
        redirect: '/DataXuetang/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DataXuetang/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/DataXuetang/RegPage'),
            },
        ]
    },
    {
        path: '/DataXueya',
        name: 'DataXueya',
        component: () => import('@/layout/IndexNew'),
        redirect: '/DataXueya/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DataXueya/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/DataXueya/RegPage'),
            },
        ]
    },
    {
        path: '/DataXinlv',
        name: 'DataXinlv',
        component: () => import('@/layout/IndexNew'),
        redirect: '/DataXinlv/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DataXinlv/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/DataXinlv/RegPage'),
            },
        ]
    },
    {
        path: '/DataGanyousanzhi',
        name: 'DataGanyousanzhi',
        component: () => import('@/layout/IndexNew'),
        redirect: '/DataGanyousanzhi/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DataGanyousanzhi/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/DataGanyousanzhi/RegPage'),
            },
        ]
    },
    {
        path: '/DataMain',
        name: 'DataMain',
        component: () => import('@/layout/IndexNew'),
        redirect: '/DataMain/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DataMain/Page'),
            },
        ]
    },
    {
        path: '/DataXueYang',
        name: 'DataXueYang',
        component: () => import('@/layout/IndexNew'),
        redirect: '/DataXueYang/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DataXueYang/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/DataXueYang/RegPage'),
            },
        ]
    },

    {
        path: '/Dishes',
        name: 'Dishes',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Dishes/InsPage',
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/Dishes/Gov/PageIns'),
            },
            {
                path: 'GovPageBus',
                component: () => import('@/views/Dishes/Gov/PageBus'),
            },

            {
                path: 'InsPage',
                component: () => import('@/views/Dishes/Ins/Page'),
            },
            {
                path: 'BusinessPage',
                component: () => import('@/views/Dishes/Business/Page'),
            },
        ]
    },
    {
        path: '/DishesPlan',
        name: 'DishesPlan',
        component: () => import('@/layout/IndexNew'),
        redirect: '/DishesPlan/InsPage',
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/DishesPlan/Ins/Page'),
            },
            {
                path: 'BusinessPage',
                component: () => import('@/views/DishesPlan/Business/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/DishesPlan/Gov/PageIns'),
            },
            {
                path: 'GovPageBus',
                component: () => import('@/views/DishesPlan/Gov/PageBus'),
            },
            {//del
                path: 'GovInsPage',
                component: () => import('@/views/DishesPlan/Gov/InsPage'),
            },
            {//del
                path: 'GovBusinessPage',
                component: () => import('@/views/DishesPlan/Gov/BusinessPage'),
            },

            {
                path: 'RegInsPage',
                component: () => import('@/views/DishesPlan/Reg/InsPage'),
            },

        ]
    },


    //#E

    {
        path: '/Elderly',
        name: 'Elderly',
        component: () => import('@/layout/IndexNew'),
        children: [

            {
                path: 'GovPage',
                component: () => import('@/views/Elderly/Gov/Page'),
            },
            {
                path: 'GovPageDisable',
                component: () => import('@/views/Elderly/Gov/PageDisable'),
            },
            {
                path: 'GovCutPage',
                component: () => import('@/views/Elderly/Gov/CutPage'),
            },
            {
                path: 'GovDeletePage',
                component: () => import('@/views/Elderly/Gov/DeletePage'),
            },
            {
                path: 'GovPageForGov',
                component: () => import('@/views/Elderly/Gov/PageForGov'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/Elderly/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/Elderly/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/Elderly/Gov/PageDayCare'),
            },


            {
                path: 'PageForBusinessServe',
                component: () => import('@/views/Elderly/PageForBusinessServe/PageForBusinessServe'),
            },
            {
                path: 'BusinessPage',
                component: () => import('@/views/Elderly/Business/Page.vue'),
            },
            {
                path: 'PageForGov',
                component: () => import('@/views/Elderly/PageForGov/PageForGov'),
            },
            {
                path: 'PageForZone',
                component: () => import('@/views/Elderly/PageForGov/PageForZone'),
            },

            {
                path: 'RegPage',
                component: () => import('@/views/Elderly/Reg/Page'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/Elderly/Ins/Page'),
            },

            {
                path: 'MedicinerPage',
                component: () => import('@/views/Elderly/Mediciner/Page'),
            },
            {
                path: 'NursePage',
                component: () => import('@/views/Elderly/Nurse/Page'),
            },
            {
                path: 'AdminPage',
                component: () => import('@/views/Elderly/Admin/Page'),
            },
        ]
    },
    {
        path: '/ElderlyReport',
        name: 'ElderlyReport',
        component: () => import('@/layout/IndexNew'),
        redirect: '/ElderlyReport/AddSub',
        children: [
            {
                path: 'AddSub',
                component: () => import('@/views/ElderlyReport/AddSub'),
            },
            {
                path: 'Balance',
                component: () => import('@/views/ElderlyReport/Balance'),
            },
            {
                path: 'ConSume',
                component: () => import('@/views/ElderlyReport/ConSume'),
            },
            {
                path: 'ElderlyClass',
                component: () => import('@/views/ElderlyReport/ElderlyClass'),
            },
            {
                path: 'ConsumeGoodsClass',
                component: () => import('@/views/ElderlyReport/ConsumeGoodsClass'),
            },
            {
                path: 'ServicePublicity',
                component: () => import('@/views/ElderlyReport/ServicePublicity'),
            },
            {
                path: 'Statistics',
                component: () => import('@/views/ElderlyReport/Statistics'),
            },
            {
                path: 'Settlement',
                component: () => import('@/views/ElderlyReport/Settlement'),
            },
            {
                path: 'Personaltransaction',
                component: () => import('@/views/ElderlyReport/Personaltransaction'),
            },
            {
                path: 'OrderStatistics',
                component: () => import('@/views/ElderlyReport/OrderStatistics'),
            },
        ]
    },
    {
        path: '/ElderlyClockin',
        name: 'ElderlyClockin',
        component: () => import('@/layout/IndexNew'),
        redirect: '/ElderlyClockin/Page',
        children: [
            {
                path: 'AdminPage',
                component: () => import('@/views/ElderlyClockin/Admin/Page'),
            },

            {
                path: 'Page',
                component: () => import('@/views/ElderlyClockin/Page'),
            },

            {
                path: 'RegPage',
                component: () => import('@/views/ElderlyClockin/Reg/Page'),
            },
        ]
    },
    {
        path: '/Error',
        name: 'Error',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Error/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Error/Page'),
            },
        ]
    },
    {
        path: '/ElderlyClass',
        name: 'ElderlyClass',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ElderlyClass/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/ElderlyClass/Gov/Page'),
            },

            {
                path: 'RegPage',
                component: () => import('@/views/ElderlyClass/Reg/Page'),
            },
        ]
    },
    {
        path: '/ElderlyCheckinAssess',
        name: 'ElderlyCheckinAssess',
        component: () => import('@/layout/IndexNew'),
        children: [

            {
                path: 'AdminPageIns',
                component: () => import('@/views/ElderlyCheckinAssess/Admin/PageIns'),
            },
            {
                path: 'AdminPageHomeBed',
                component: () => import('@/views/ElderlyCheckinAssess/Admin/PageHomeBed'),
            },
            {
                path: 'AdminPageDayCare',
                component: () => import('@/views/ElderlyCheckinAssess/Admin/PageDayCare'),
            },

            {//del
                path: 'GovPage',
                component: () => import('@/views/ElderlyCheckinAssess/Gov/Page'),
            },


            {
                path: 'GovPageIns',
                component: () => import('@/views/ElderlyCheckinAssess/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/ElderlyCheckinAssess/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/ElderlyCheckinAssess/Gov/PageDayCare'),
            },


            {
                path: 'RegPageIns',
                component: () => import('@/views/ElderlyCheckinAssess/Reg/PageIns'),
            },
            {
                path: 'RegPageHomeBed',
                component: () => import('@/views/ElderlyCheckinAssess/Reg/PageHomeBed'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/ElderlyCheckinAssess/Ins/Page'),
            },
            {
                path: 'DoctorPage',
                component: () => import('@/views/ElderlyCheckinAssess/Doctor/Page'),
            },
            {
                path: 'NurseAidePage',
                component: () => import('@/views/ElderlyCheckinAssess/NurseAide/Page'),
            }
        ]
    },
    {
        path: '/ElderlyDrugRecord',
        name: 'ElderlyDrugRecord',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/ElderlyDrugRecord/Ins/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/ElderlyDrugRecord/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/ElderlyDrugRecord/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/ElderlyDrugRecord/Gov/PageDayCare'),
            }
        ]
    },
    {
        path: '/ElderlyDrugRecord',
        name: 'ElderlyDrugRecord',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/ElderlyDrugRecord/Ins/Page'),
            }
        ]
    },

    //#F

    //#G
    {
        path: '/Government',
        name: 'Government',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Government/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Government/Page'),
            },
            {
                path: 'Set',
                component: () => import('@/views/Government/Set'),
            },
            {
                path: 'Approve',
                component: () => import('@/views/Government/Approve'),
            },
        ]
    },
    {
        path: '/GoodsClass',
        name: 'GoodsClass',
        component: () => import('@/layout/IndexNew'),
        redirect: '/GoodsClass/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Goods/GoodClass/Page'),
            },
        ]
    },
    {
        path: '/GoodsClassBusiness',
        name: 'GoodsClassBusiness',
        component: () => import('@/layout/IndexNew'),
        redirect: '/GoodsClassBusiness/Page',
        children: [
            {
                path: 'GovPageHome',
                component: () => import('@/views/GoodsClassBusiness/Gov/PageHome'),
            },
            {
                path: 'GovPageDisable',
                component: () => import('@/views/GoodsClassBusiness/Gov/PageDisable'),
            },
            {
                path: 'GovPageJiFen',
                component: () => import('@/views/GoodsClassBusiness/Gov/PageJiFen'),
            },
            {
                path: 'GovPagePad',
                component: () => import('@/views/GoodsClassBusiness/Gov/PagePad'),
            },
            {
                path: 'GovPageTrip',
                component: () => import('@/views/GoodsClassBusiness/Gov/PageTrip'),
            },

            {
                path: 'Page',
                component: () => import('@/views/Goods/GoodsClassBusiness/Page'),
            },
        ]
    },
    {
        path: '/GoodsClassGov',
        name: 'GoodsClassGov',
        component: () => import('@/layout/IndexNew'),
        redirect: '/GoodsClassGov/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Goods/GoodsClassGov/Page'),
            },
        ]
    },
    {
        path: '/GoodsAttribute',
        name: 'GoodsAttribute',
        component: () => import('@/layout/IndexNew'),
        redirect: '/GoodsAttribute/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Goods/GoodsAttribute/Page'),
            },
        ]
    },
    {
        path: '/GoodSize',
        name: 'GoodSize',
        component: () => import('@/layout/IndexNew'),
        redirect: '/GoodSize/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Goods/GoodSize/Page'),
            },
        ]
    },
    {
        path: '/GoodColor',
        name: 'GoodColor',
        component: () => import('@/layout/IndexNew'),
        redirect: '/GoodColor/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Goods/GoodColor/Page'),
            },
        ]
    },
    {
        path: '/Goods',
        name: 'Goods',
        component: () => import('@/layout/IndexNew'),
        children: [
            {//del
                path: 'GovPage',
                component: () => import('@/views/Goods/Gov/Page'),
            },

            {
                path: 'GovPageHome',
                component: () => import('@/views/Goods/Gov/PageHome'),
            },
            {
                path: 'GovPageDisable',
                component: () => import('@/views/Goods/Gov/PageDisable'),
            },
            {
                path: 'GovPageJiFen',
                component: () => import('@/views/Goods/Gov/PageJiFen'),
            },
            {
                path: 'GovPagePad',
                component: () => import('@/views/Goods/Gov/PagePad'),
            },
            {
                path: 'GovPageTrip',
                component: () => import('@/views/Goods/Gov/PageTrip'),
            },

            {
                path: 'RegPage',
                component: () => import('@/views/Goods/Reg/Page'),
            },
            {
                path: 'RegPagePad',
                component: () => import('@/views/Goods/Reg/PagePad'),
            },

            {
                path: 'BusinessPage',
                component: () => import('@/views/Goods/Business/Page'),
            },
            {
                path: 'BusinessPagePad',
                component: () => import('@/views/Goods/Business/PagePad'),
            },
            {
                path: 'BusinessPageJiFen',
                component: () => import('@/views/Goods/Business/PageJiFen'),
            },

            {
                path: 'BusinessPageAll',
                component: () => import('@/views/Goods/Business/PageAll'),
            },

            {
                path: 'BusinessPageDelete',
                component: () => import('@/views/Goods/Business/PageDelete'),
            },
            {
                path: 'BusinessPageAll',
                component: () => import('@/views/Goods/Business/PageAll'),
            },


        ]
    },
    {
        path: '/GroupDeviceCamera',
        name: 'GroupDeviceCamera',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/GroupDevice/Camera/Ins/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/GroupDevice/Camera/Gov/PageIns'),
            },

            {
                path: 'RegPageIns',
                component: () => import('@/views/GroupDevice/Camera/Reg/PageIns'),
            },
        ]
    },
    {
        path: '/GroupDeviceSixPC',
        name: 'GroupDeviceSixPC',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/GroupDevice/SixPC/Ins/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/GroupDevice/SixPC/Gov/PageIns'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/GroupDevice/SixPC/Gov/PageDayCare'),
            },
            {
                path: 'RegPageIns',
                component: () => import('@/views/GroupDevice/SixPC/Reg/PageIns'),
            },
        ]
    },
    {
        path: '/GroupDeviceGareaPC',
        name: 'GroupDeviceGareaPC',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/GroupDevice/GareaPC/Ins/Page'),
            },
            {//del
                path: 'GovPage',
                component: () => import('@/views/GroupDevice/GareaPC/Gov/Page'),
            },
            {
                path: 'GovPageIns',
                component: () => import('@/views/GroupDevice/GareaPC/Gov/PageIns'),
            },
            {
                path: 'RegPageIns',
                component: () => import('@/views/GroupDevice/GareaPC/Reg/PageIns'),
            },
        ]
    },
    {
        path: '/GroupDeviceYueQiPC',
        name: 'GroupDeviceYueQiPC',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/GroupDevice/YueQiPC/Ins/Page'),
            },
            {
                path: 'GovPageIns',
                component: () => import('@/views/GroupDevice/YueQiPC/Gov/PageIns'),
            },
        ]
    },


    //#H
    {
        path: '/home',
        name: 'Home',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'index',
                component: () => import('@/views/home/Switchover'),
            },
            {
                path: 'switch',
                component: () => import('@/views/home/Switchover'),
            },
        ]
    },

    //#I
    {
        path: '/ICCard',
        name: 'ICCard',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPage',
                component: () => import('@/views/ICCard/Gov/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/ICCard/Reg/Page'),
            },
            {
                path: 'ZonePage',
                component: () => import('@/views/ICCard/Zone/Page'),
            },
        ]
    },
    {
        path: '/Institution',
        name: 'Institution',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'AdminPage',
                component: () => import('@/views/Institution/Admin/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/Institution/Gov/Page'),
            },
            {
                path: 'GovPageIns',
                component: () => import('@/views/Institution/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/Institution/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/Institution/Gov/PageDayCare'),
            },

            {
                path: 'RegPageIns',
                component: () => import('@/views/Institution/Reg/PageIns'),
            },
            {
                path: 'RegPageHomeBed',
                component: () => import('@/views/Institution/Reg/PageHomeBed'),
            },
            {
                path: 'RegPageDayCare',
                component: () => import('@/views/Institution/Reg/PageDayCare'),
            },
        ]
    },
    {
        path: '/Inventory',
        name: 'Inventory',
        component: () => import('@/layout/IndexNew'),
        children: [
            {//del
                path: 'Page',
                component: () => import('@/views/Inventory/Page'),
            },
            {//del
                path: 'Cart',
                component: () => import('@/views/Inventory/Cart'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/Inventory/Gov/PageIns'),
            },
            {
                path: 'InsPageIns',
                component: () => import('@/views/Inventory/Ins/PageIns'),
            },

        ]
    },
    {
        path: '/ImprestRecord',
        name: 'ImprestRecord',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/ImprestRecord/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/ImprestRecord/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/ImprestRecord/Gov/PageDayCare'),
            },


            {
                path: 'Page',
                component: () => import('@/views/ImprestRecord/Page'),
            },
        ]
    },

    //#J



    //#L
    {
        path: '/Log',
        name: 'Log',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Log/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Log/Page'),
            },
        ]
    },
    {
        path: '/LeaveRecord',
        name: 'LeaveRecord',
        component: () => import('@/layout/IndexNew'),
        redirect: '/LeaveRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/LeaveRecord/Page'),
            },
            {
                path: 'GovPageIns',
                component: () => import('@/views/LeaveRecord/Gov/PageIns'),
            },
        ]
    },
    {
        path: '/LessBalance',
        name: 'LessBalance',
        component: () => import('@/layout/IndexNew'),
        redirect: '/LessBalance/InsPage',
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/LessBalance/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/LessBalance/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/LessBalance/Gov/PageDayCare'),
            },


            {
                path: 'InsPage',
                component: () => import('@/views/LessBalance/Ins/Page'),
            },

        ]
    },
    {
        path: '/LessDay',
        name: 'LessDay',
        component: () => import('@/layout/IndexNew'),
        redirect: '/LessDay/InsPage',
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/LessDay/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/LessDay/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/LessDay/Gov/PageDayCare'),
            },

            {
                path: 'InsPage',
                component: () => import('@/views/LessDay/Ins/Page'),
            },

        ]
    },

    //#M
    {
        path: '/Menu',
        name: 'Menu',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Menu/List',
        children: [
            {
                path: 'List',
                component: () => import('@/views/Menu/List'),
            },
        ]
    },
    {
        path: '/MedicationGroup',
        name: 'MedicationGroup',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/MedicationGroup/Ins/Page'),
            },
            {//del
                path: 'GovPage',
                component: () => import('@/views/MedicationGroup/Gov/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/MedicationGroup/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/MedicationGroup/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/MedicationGroup/Gov/PageDayCare'),
            },

        ]
    },
    {
        path: '/MedicationRecord',
        name: 'MedicationRecord',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'AdminPageIns',
                component: () => import('@/views/MedicationRecord/Admin/PageIns'),
            },
            {
                path: 'AdminPageHomeBed',
                component: () => import('@/views/MedicationRecord/Admin/PageHomeBed'),
            },
            {
                path: 'AdminPageDayCare',
                component: () => import('@/views/MedicationRecord/Admin/PageDayCare'),
            },

            {
                path: 'InsPage',
                component: () => import('@/views/MedicationRecord/Ins/Page'),
            },

            {//del
                path: 'GovPage',
                component: () => import('@/views/MedicationRecord/Gov/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/MedicationRecord/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/MedicationRecord/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/MedicationRecord/Gov/PageDayCare'),
            },

            {
                path: 'RegPageIns',
                component: () => import('@/views/MedicationRecord/Reg/PageIns'),
            },
            {
                path: 'RegPageHomeBed',
                component: () => import('@/views/MedicationRecord/Reg/PageHomeBed'),
            }
        ]
    },
    {
        path: '/MedicationScheduling',
        name: 'MedicationScheduling',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'AdminPageIns',
                component: () => import('@/views/MedicationScheduling/Admin/PageIns'),
            },
            {
                path: 'AdminPageHomeBed',
                component: () => import('@/views/MedicationScheduling/Admin/PageHomeBed'),
            },
            {
                path: 'AdminPageDayCare',
                component: () => import('@/views/MedicationScheduling/Admin/PageDayCare'),
            },

            {
                path: 'InsPage',
                component: () => import('@/views/MedicationScheduling/Ins/Page'),
            },

            {//del
                path: 'GovPage',
                component: () => import('@/views/MedicationScheduling/Gov/Page'),
            },
            {
                path: 'GovPageIns',
                component: () => import('@/views/MedicationScheduling/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/MedicationScheduling/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/MedicationScheduling/Gov/PageDayCare'),
            },

            {
                path: 'RegPageIns',
                component: () => import('@/views/MedicationScheduling/Reg/PageIns'),
            },
            {
                path: 'RegPageHomeBed',
                component: () => import('@/views/MedicationScheduling/Reg/PageHomeBed'),
            }
        ]
    },
    {
        path: '/Mediciner',
        name: 'Mediciner',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/Mediciner/Ins/Page'),
            },
            {//del
                path: 'GovPage',
                component: () => import('@/views/Mediciner/Gov/Page'),
            },
            {
                path: 'GovPageIns',
                component: () => import('@/views/Mediciner/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/Mediciner/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/Mediciner/Gov/PageDayCare'),
            },


            {
                path: 'RegPageIns',
                component: () => import('@/views/Mediciner/Reg/PageIns'),
            },
        ]
    },



    //#N
    {
        path: '/NurseAide',
        name: 'NurseAide',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/NurseAide/Ins/Page'),
            },
            {//del
                path: 'GovPage',
                component: () => import('@/views/NurseAide/Gov/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/NurseAide/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/NurseAide/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/NurseAide/Gov/PageDayCare'),
            },

            {
                path: 'RegPageIns',
                component: () => import('@/views/NurseAide/Reg/PageIns'),
            },
            {
                path: 'RegPageHomeBed',
                component: () => import('@/views/NurseAide/Reg/PageHomeBed'),
            },
        ]
    },
    {
        path: '/Nurse',
        name: 'Nurse',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/Nurse/Ins/Page'),
            },
            {//del
                path: 'GovPage',
                component: () => import('@/views/Nurse/Gov/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/Nurse/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/Nurse/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/Nurse/Gov/PageDayCare'),
            },

            {
                path: 'RegPageIns',
                component: () => import('@/views/Nurse/Reg/PageIns'),
            },
            {
                path: 'RegPageHomeBed',
                component: () => import('@/views/Nurse/Reg/PageHomeBed'),
            },
        ]
    },
    {
        path: '/NursingItem',
        name: 'NursingItem',
        component: () => import('@/layout/IndexNew'),
        redirect: '/NursingItem/GovPage',
        children: [
            {//del
                path: 'GovPage',
                component: () => import('@/views/NursingItem/Gov/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/NursingItem/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/NursingItem/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/NursingItem/Gov/PageDayCare'),
            },

            {
                path: 'InsPage',
                component: () => import('@/views/NursingItem/Ins/Page'),
            }
        ]
    },
    {
        path: '/NursingLevel',
        name: 'NursingLevel',
        component: () => import('@/layout/IndexNew'),
        redirect: '/NursingLevel/GovPage',
        children: [
            {//del
                path: 'GovPage',
                component: () => import('@/views/NursingLevel/Gov/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/NursingLevel/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/NursingLevel/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/NursingLevel/Gov/PageDayCare'),
            },

            {
                path: 'InsPage',
                component: () => import('@/views/NursingLevel/Ins/Page'),
            },

        ]
    },
    {
        path: '/NursingType',
        name: 'NursingType',
        component: () => import('@/layout/IndexNew'),
        redirect: '/NursingType/GovPage',
        children: [
            {//del
                path: 'GovPage',
                component: () => import('@/views/NursingType/Gov/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/NursingType/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/NursingType/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/NursingType/Gov/PageDayCare'),
            },

            {
                path: 'InsPage',
                component: () => import('@/views/NursingType/Ins/Page'),
            },
        ]
    },
    {
        path: '/NursingRecord',
        name: 'NursingRecord',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'AdminPageIns',
                component: () => import('@/views/NursingRecord/Admin/PageIns'),
            },
            {
                path: 'AdminPageHomeBed',
                component: () => import('@/views/NursingRecord/Admin/PageHomeBed'),
            },
            {
                path: 'AdminPageDayCare',
                component: () => import('@/views/NursingRecord/Admin/PageDayCare'),
            },

            {//del
                path: 'GovPage',
                component: () => import('@/views/NursingRecord/Gov/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/NursingRecord/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/NursingRecord/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/NursingRecord/Gov/PageDayCare'),
            },

            {
                path: 'RegPageIns',
                component: () => import('@/views/NursingRecord/Reg/PageIns'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/NursingRecord/Ins/Page'),
            },
            {
                path: 'MedicinerPage',
                component: () => import('@/views/NursingRecord/Mediciner/Page'),
            },
            {
                path: 'NursePage',
                component: () => import('@/views/NursingRecord/Nurse/Page'),
            },
        ]
    },
    {
        path: '/NursingScheduling',
        name: 'NursingScheduling',
        component: () => import('@/layout/IndexNew'),
        children: [
            {//del
                path: 'GovPage',
                component: () => import('@/views/NursingScheduling/Gov/Page'),
            },
            {
                path: 'GovPageIns',
                component: () => import('@/views/NursingScheduling/Gov/PageIns'),
            },
            {
                path: 'RegPageIns',
                component: () => import('@/views/NursingScheduling/Reg/PageIns'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/NursingScheduling/Ins/Page'),
            },
            {
                path: 'MedicinerPage',
                component: () => import('@/views/NursingScheduling/Mediciner/Page'),
            },
            {
                path: 'NursePage',
                component: () => import('@/views/NursingScheduling/Nurse/Page'),
            },
        ]
    },

    //#O
    {
        path: '/Order',
        name: 'Order',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Order/SummaryStatistics',
        children: [
            {
                path: 'SummaryStatistics',
                component: () => import('@/views/Order/SummaryStatistics/Page'),
            },
            {
                path: 'ConsumeStatistics',
                component: () => import('@/views/Order/ConsumeStatistics/Page'),
            },
            {
                path: 'ConsumeFlow',
                component: () => import('@/views/Order/ConsumeFlow/Page'),
            },
            {
                path: 'UserOrderReport',
                component: () => import('@/views/Order/UserOrderReport/Page'),
            },
            {
                path: 'ConsumeFlowForBusiness',
                component: () => import('@/views/Order/ConsumeFlowForBusiness/Page'),
            },
            {
                path: 'Water',
                component: () => import('@/views/Order/WaterForGov/Page'),
            },
            {
                path: 'ConsumeStatistics',
                component: () => import('@/views/Order/ConsumeStatistics/Page'),
            },
            {
                path: 'BusinessOrderStatistics',
                component: () => import('@/views/Order/BusinessOrderStatistics/Page2'),
            },
            {
                path: 'BusinessOrderStatisticsReg',
                component: () => import('@/views/Order/BusinessOrderStatistics/RegPage'),
            },

        ]
    },
    {
        path: '/OrderBusiness',
        name: 'OrderBusiness',
        component: () => import('@/layout/IndexNew'),
        children: [

            {
                path: 'AdminElderlyOrder',
                component: () => import('@/views/OrderBusiness/Admin/ElderlyOrder'),
            },
            {
                path: 'AdminCashierOrder',
                component: () => import('@/views/OrderBusiness/Admin/CashierOrder'),
            },
            {
                path: 'AdminOnlinePay',
                component: () => import('@/views/OrderBusiness/Admin/OnlinePay'),
            },


            {
                path: 'GovBusinessOrder',
                component: () => import('@/views/OrderBusiness/Gov/BusinessOrder'),
            },
            {
                path: 'GovBusinessOrderDisable',
                component: () => import('@/views/OrderBusiness/Gov/BusinessOrderDisable'),
            },
            {
                path: 'GovServeOrder',
                component: () => import('@/views/OrderBusiness/Gov/ServeOrder'),
            },
            {
                path: 'GovServeOrderDisable',
                component: () => import('@/views/OrderBusiness/Gov/ServeOrderDisable'),
            },
            {
                path: 'GovElderlyOrder',
                component: () => import('@/views/OrderBusiness/Gov/ElderlyOrder'),
            },
            {
                path: 'GovElderlyOrderDisable',
                component: () => import('@/views/OrderBusiness/Gov/ElderlyOrderDisable'),
            },
            {
                path: 'GovPageReturnVisitDisable',
                component: () => import('@/views/OrderBusiness/Gov/PageReturnVisitDisable'),
            },
            {
                path: 'GovDeleteOrder',
                component: () => import('@/views/OrderBusiness/Gov/DeleteOrder'),
            },
            {
                path: 'GovElderlyOrderJiFen',
                component: () => import('@/views/OrderBusiness/Gov/ElderlyOrderJiFen'),
            },
            {
                path: 'GovWritePage',
                component: () => import('@/views/OrderBusiness/Gov/WritePage'),
            },
            {
                path: 'GovWritePageDisable',
                component: () => import('@/views/OrderBusiness/Gov/WritePageDisable'),
            },
            {
                path: 'GovOnlinePay',
                component: () => import('@/views/OrderBusiness/Gov/OnlinePay'),
            },


            {
                path: 'RegElderlyOrder',
                component: () => import('@/views/OrderBusiness/Reg/ElderlyOrder'),
            },
            {
                path: 'BusinessCashierOrder',
                component: () => import('@/views/OrderBusiness/Business/CashierOrder'),
            },
            {
                path: 'BusinessClientOrder',
                component: () => import('@/views/OrderBusiness/Business/ClientOrder'),
            },
            {
                path: 'BusinessElderlyOrder',
                component: () => import('@/views/OrderBusiness/Business/ElderlyOrder'),
            },
            {
                path: 'BusinessWritePage',
                component: () => import('@/views/OrderBusiness/Business/WritePage'),
            },
            {
                path: 'BusinessDeleteOrder',
                component: () => import('@/views/OrderBusiness/Business/DeleteOrder'),
            },


            {
                path: 'GovPageServeSingle',
                component: () => import('@/views/OrderBusiness/Gov/PageServeSingle'),
            },


            {
                path: 'DishesOrder',
                component: () => import('@/views/OrderBusiness/Business/DishesOrder'),
            },
            {
                path: 'ServiceOrderForAdm',
                component: () => import('@/views/OrderBusiness/PageForAdm/ServiceOrderForAdm'),
            },
            {
                path: 'CommonOrderForAdm',
                component: () => import('@/views/OrderBusiness/PageForAdm/CommonOrderForAdm'),
            },
            {
                path: 'PageSchedule',
                component: () => import('@/views/OrderBusiness/PageSchedule/Page'),
            },
            {
                path: 'Page',
                component: () => import('@/views/OrderBusiness/Page/Page'),
            },
            {
                path: 'PageForStaff',
                component: () => import('@/views/OrderBusiness/PageForStaff/PageForStaff'),
            },
            {
                path: 'PageScheduleServe',
                component: () => import('@/views/OrderBusiness/PageScheduleServe/Page'),
            },
            {
                path: 'PageServe',
                component: () => import('@/views/OrderBusiness/PageServe/Page'),
            },
        ]
    },
    {
        path: '/OrderBusinessAppraise',
        name: 'OrderBusinessAppraise',
        component: () => import('@/layout/IndexNew'),
        redirect: '/OrderBusinessAppraise/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/OrderBusinessAppraise/Page'),
            },
            {
                path: 'PageForStaff',
                component: () => import('@/views/OrderBusinessAppraise/PageForStaff'),
            },
            {
                path: 'PageServe',
                component: () => import('@/views/OrderBusinessAppraise/PageServe/Page'),
            },
            {
                path: 'GovPageDisable',
                component: () => import('@/views/OrderBusinessAppraise/Gov/PageDisable'),
            },
        ]
    },






    //#P
    {
        path: '/PlaceAnOrderCall',
        name: 'PlaceAnOrderCall',
        component: () => import('@/views/PlaceAnOrderCall/Page'),
    },

    {
        path: '/Positioning',
        name: 'Positioning',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Elderly/Positioning/Page'),
            },
        ]
    },
    {
        path: '/PracticeSite',
        name: 'PracticeSite',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'CommandCenterPage',
                component: () => import('@/views/PracticeSite/CommandCenter/Page'),
            },
            {
                path: 'CommandCenterPageApply',
                component: () => import('@/views/PracticeSite/CommandCenter/PageApply'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/PracticeSite/Gov/Page'),
            },

            {
                path: 'RegPage',
                component: () => import('@/views/PracticeSite/Reg/Page'),
            },
        ]
    },


    //#R
    {
        path: '/Role',
        name: 'Role',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Role/Page',
        children: [
            {//del
                path: 'Page',
                component: () => import('@/views/Role/Page'),
            },
            {
                path: 'SuperPage',
                component: () => import('@/views/Role/Super/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/Role/Gov/Page'),
            },

        ]
    },
    {
        path: '/Remind',
        name: 'Remind',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Remind/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Remind/Page'),
            },
        ]
    },
    {
        path: '/Recharge',
        name: 'Recharge',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Recharge/Page',
        children: [
            {
                path: 'AdminPage',
                component: () => import('@/views/Recharge/Admin/Page'),
            },

            {
                path: 'GovPage',
                component: () => import('@/views/Recharge/Gov/Page'),
            },
            {
                path: 'GovPageIns',
                component: () => import('@/views/Recharge/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/Recharge/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/Recharge/Gov/PageDayCare'),
            },


            {
                path: 'RegPage',
                component: () => import('@/views/Recharge/Reg/Page'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/Recharge/Ins/Page'),
            },
            {
                path: 'BusinessPage',
                component: () => import('@/views/Recharge/Business/Page'),
            },
        ]
    },
    {
        path: '/Report',
        name: 'Report',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Report/PageGov',
        children: [
            {
                path: 'PageGov',
                component: () => import('@/views/Report/PageGov'),
            },
        ]
    },

    {
        path: '/Room',
        name: 'Room',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/Room/Ins/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/Room/Gov/Page'),
            }
        ]
    },
    {
        path: '/RoomType',
        name: 'RoomType',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/RoomType/Ins/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/RoomType/Gov/Page'),
            }

        ]
    },
    {
        path: '/RetreatSettle',
        name: 'RetreatSettle',
        component: () => import('@/layout/IndexNew'),
        redirect: '/RetreatSettle/InsPage',
        children: [
            {
                path: 'InsPage',
                component: () => import('@/views/RetreatSettle/Ins/Page'),
            },
        ]
    },
    {
        path: '/RefundRecord',
        name: 'RefundRecord',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/RefundRecord/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/RefundRecord/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/RefundRecord/Gov/PageDayCare'),
            },

            {
                path: 'Page',
                component: () => import('@/views/RefundRecord/Page'),
            },

        ]
    },
    {
        path: '/ReceptionRecord',
        name: 'ReceptionRecord',
        component: () => import('@/layout/IndexNew'),
        redirect: '/ReceptionRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ReceptionRecord/Page'),
            },
            {
                path: 'GovPageIns',
                component: () => import('@/views/ReceptionRecord/Gov/PageIns'),
            },
        ]
    },


    //#S
    {
        path: '/Staff',
        name: 'Staff',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovCommandCenterPage',
                component: () => import('@/views/Staff/Gov/CommandCenter/Page'),
            },
            {
                path: 'GovInsPage',
                component: () => import('@/views/Staff/Gov/Ins/Page'),
            },
            {
                path: 'GovSupervisePage',
                component: () => import('@/views/Staff/Gov/Supervise/Page'),
            },
            {
                path: 'GovZonePage',
                component: () => import('@/views/Staff/Gov/Zone/Page'),
            },
            {
                path: 'GovAutoPage',
                component: () => import('@/views/Staff/Gov/Auto/Page'),
            },


            {
                path: 'InsMedicinerPage',
                component: () => import('@/views/Staff/Ins/Mediciner/Page'),
            },
            {
                path: 'InsNursePage',
                component: () => import('@/views/Staff/Ins/Nurse/Page'),
            },


            {
                path: 'Page',
                component: () => import('@/views/Staff/ForSuper/Page'),
            },
            {
                path: 'PageGov',
                component: () => import('@/views/Staff/ForGov/Page'),
            },

            {
                path: 'PageAdm',
                component: () => import('@/views/Staff/ForAdmin/Page'),
            },
            {
                path: 'SeatsPage',
                component: () => import('@/views/Staff/ForSeats/Page'),
            },
            {
                path: 'PageBusiness',
                component: () => import('@/views/Staff/ForBusiness/Page'),
            },
        ]
    },
    {
        path: '/Service',
        name: 'Service',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Service/Page',
        children: [
            {
                path: 'GovPage',
                component: () => import('@/views/Service/Gov/Page'),
            },
            {
                path: 'GovPageDisable',
                component: () => import('@/views/Service/Gov/PageDisable'),
            },
            {
                path: 'Page',
                component: () => import('@/views/Service/Page'),
            },
        ]
    },
    {
        path: '/Seats',
        name: 'Seats',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Seats/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Seats/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/Seats/Gov/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/Seats/Reg/Page'),
            }
        ]
    },
    {
        path: '/Supplier',
        name: 'Supplier',
        component: () => import('@/layout/IndexNew'),
        children: [
            {//del
                path: 'Page',
                component: () => import('@/views/Supplier/Page'),
            },

            {
                path: 'GovPageIns',
                component: () => import('@/views/Supplier/Gov/PageIns'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/Supplier/Ins/Page'),
            }
        ]
    },
    {
        path: '/StockIn',
        name: 'StockIn',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/StockIn/Gov/PageIns'),
            },
            {
                path: 'InsPageIns',
                component: () => import('@/views/StockIn/Ins/PageIns'),
            }
        ]
    },
    {
        path: '/StockOut',
        name: 'StockOut',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/StockOut/Gov/PageIns'),
            },
            {
                path: 'InsPageIns',
                component: () => import('@/views/StockOut/Ins/PageIns'),
            }
        ]
    },
    {
        path: '/SocialWorker',
        name: 'SocialWorker',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPage',
                component: () => import('@/views/SocialWorker/Gov/Page'),
            },

        ]
    },
    {
        path: '/SettlementGovernment',
        name: 'SettlementGovernment',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'AdmPage',
                component: () => import('@/views/SettlementGovernment/Adm/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/SettlementGovernment/Gov/Page'),
            },

        ]
    },

    //#T
    {
        path: '/TotalLess',
        name: 'TotalLess',
        component: () => import('@/layout/IndexNew'),
        redirect: '/TotalLess/InsPage',
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/TotalLess/Gov/PageIns'),
            },
            {
                path: 'GovPageHomeBed',
                component: () => import('@/views/TotalLess/Gov/PageHomeBed'),
            },
            {
                path: 'GovPageDayCare',
                component: () => import('@/views/TotalLess/Gov/PageDayCare'),
            },

            {
                path: 'InsPage',
                component: () => import('@/views/TotalLess/Ins/Page'),
            },

        ]
    },
    {
        path: '/TrainClass',
        name: 'TrainClass',
        component: () => import('@/layout/IndexNew'),
        redirect: '/TrainClass/CmdCentPage',
        children: [
            {
                path: 'CmdCentPage',
                component: () => import('@/views/TrainClass/CmdCent/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/TrainClass/Gov/Page'),
            },
        ]
    },
    {
        path: '/Train',
        name: 'Train',
        component: () => import('@/layout/IndexNew'),
        redirect: '/Train/CmdCentPage',
        children: [
            {
                path: 'CmdCentPage',
                component: () => import('@/views/Train/CmdCent/Page'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/Train/Gov/Page'),
            },
            {
                path: 'RegPage',
                component: () => import('@/views/Train/Reg/Page'),
            },
        ]
    },
    {
        path: '/TotalBusinessOrder',
        name: 'TotalBusinessOrder',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPage',
                component: () => import('@/views/TotalBusinessOrder/Gov/Page'),
            },
            {
                path: 'GovPageSettlementRecord',
                component: () => import('@/views/TotalBusinessOrder/Gov/PageSettlementRecord'),
            },
            {
                path: 'GovPageGoods',
                component: () => import('@/views/TotalBusinessOrder/Gov/PageGoods'),
            },

            {
                path: 'RegPage',
                component: () => import('@/views/TotalBusinessOrder/Reg/Page'),
            },
            {
                path: 'RegPageSettlementRecord',
                component: () => import('@/views/TotalBusinessOrder/Reg/PageSettlementRecord'),
            },
            {
                path: 'RegPageGoods',
                component: () => import('@/views/TotalBusinessOrder/Reg/PageGoods'),
            },

        ]
    },

    //#U
    {
        path: '/User',
        name: 'User',
        component: () => import('@/layout/IndexNew'),
        redirect: '/User/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/User/Page'),
            },
        ]
    },
    {
        path: '/UserFace',
        name: 'UserFace',
        component: () => import('@/layout/IndexNew'),
        children: [

            {
                path: 'GovElderlyPageIns',
                component: () => import('@/views/UserFace/Gov/Elderly/PageIns'),
            },
            {
                path: 'RegElderlyPageIns',
                component: () => import('@/views/UserFace/Reg/Elderly/PageIns'),
            },

            {
                path: 'GovMedicinerPageIns',
                component: () => import('@/views/UserFace/Gov/Mediciner/PageIns'),
            },
            {
                path: 'RegMedicinerPageIns',
                component: () => import('@/views/UserFace/Reg/Mediciner/PageIns'),
            },

            {
                path: 'GovNursePageIns',
                component: () => import('@/views/UserFace/Gov/Nurse/PageIns'),
            },
            {
                path: 'RegNursePageIns',
                component: () => import('@/views/UserFace/Reg/Nurse/PageIns'),
            },

            {
                path: 'GovNurseAidePage',
                component: () => import('@/views/UserFace/Gov/NurseAide/Page'),
            },
            {
                path: 'InsElderlyPage',
                component: () => import('@/views/UserFace/Ins/Elderly/Page'),
            },
            {
                path: 'InsMedicinerPage',
                component: () => import('@/views/UserFace/Ins/Mediciner/Page'),
            },
            {
                path: 'InsNursePage',
                component: () => import('@/views/UserFace/Ins/Nurse/Page'),
            },
            {
                path: 'InsNurseAidePage',
                component: () => import('@/views/UserFace/Ins/NurseAide/Page'),
            },
        ]
    },
    {
        path: '/UploadMul',
        name: 'UploadMul',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPage',
                component: () => import('@/views/UploadMul/Gov/Page'),
            },
        ]
    },

    //#V
    {
        path: '/VolunteerTeam',
        name: 'VolunteerTeam',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'CommandCenterPage',
                component: () => import('@/views/VolunteerTeam/CommandCenter/Page'),
            },
            {
                path: 'CommandCenterPageApply',
                component: () => import('@/views/VolunteerTeam/CommandCenter/PageApply'),
            },
            {
                path: 'GovPage',
                component: () => import('@/views/VolunteerTeam/Gov/Page'),
            },

            {
                path: 'RegPage',
                component: () => import('@/views/VolunteerTeam/Reg/Page'),
            },
        ]
    },
    {
        path: '/Volunteer',
        name: 'Volunteer',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'CmdPage',
                component: () => import('@/views/Volunteer/CommandCenter/Page'),
            },
        ]
    },

    //#W
    {
        path: '/Warehouse',
        name: 'Warehouse',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/Warehouse/Gov/PageIns'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/Warehouse/Ins/Page'),
            },
        ]
    },
    {
        path: '/WaresType',
        name: 'WaresType',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/WaresType/Gov/PageIns'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/WaresType/Ins/Page'),
            },
        ]
    },
    {
        path: '/Wares',
        name: 'Wares',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/Wares/Gov/PageIns'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/Wares/Ins/Page'),
            },
        ]
    },
    {
        path: '/WaresInOut',
        name: 'WaresInOut',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'GovPageIns',
                component: () => import('@/views/WaresInOut/Gov/PageIns'),
            },
            {
                path: 'InsPage',
                component: () => import('@/views/WaresInOut/Ins/Page'),
            },

        ]
    },


    //#Z
    {
        path: '/Zone',
        name: 'Zone',
        component: () => import('@/layout/IndexNew'),
        children: [
            {
                path: 'List',
                component: () => import('@/views/Zone/List'),
            },
            {
                path: 'RegList',
                component: () => import('@/views/Zone/Reg/List'),
            },
        ]
    },





    // 404 page must be placed at the end !!!
    { path: '*', redirect: '/404', hidden: true }

]

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}


export default router
